import React, { useEffect, useState } from 'react'
import { getDateNow , convertDateToString } from '../utils'

export const ContextAbsence = React.createContext<any>({})


export default function ContextAbsenceModels(props: any) {
    const [jsonParmsAbsence, setJsonParmsAbsence] = useState<any>({ 'from': getDateNow(), 'to': getDateNow() , 'page':1 , 'user':[] })
    const [activeFilterAbsence, setActiveFilterAbsence] = useState<any>({
        'activePeriod': -1 ,
        'type':-1 ,
        'user':[],
        'startCalender':new Date() ,
        'endCalender':new Date() ,
    })




    return (
        <ContextAbsence.Provider value={{
            activeFilterAbsence,
            setActiveFilterAbsence ,
            jsonParmsAbsence ,
            setJsonParmsAbsence
        }}>
            {props.children}
        </ContextAbsence.Provider>
    )
}